import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { ClassNameProp } from '@swf/core/types/Props';

import View from '../View/View';

import {
  TXTMOB_My_Tickets,
  TXTWCL_Please_login_to_our_downloadab_ELL,
  TXTWCL_Tournament_tickets_are_current_ELL
} from './TournamentTickets.messages.json';

export const TournamentTicketsBody: React.FC<Partial<ClassNameProp>> = ({ className }) => (
  <div className={className}>
    <Translation tagName="p" {...TXTWCL_Tournament_tickets_are_current_ELL} />
    <Translation tagName="p" {...TXTWCL_Please_login_to_our_downloadab_ELL} />
  </div>
);

const TournamentTickets: React.FC = () => (
  <View title={<Translation {...TXTMOB_My_Tickets} />}>
    <TournamentTicketsBody />
  </View>
);

export default TournamentTickets;
